import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { firestore } from 'services/firebase/client';

const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const SUFFIX_LENGTH = 6;
const MAX_ATTEMPTS = 20;

function getFirstName(fullName: string): string {
  const first = fullName?.trim().split(/\s+/)[0];
  return first || 'Indicacao';
}

function generateAlphanumericSuffix(): string {
  let suffix = '';
  for (let i = 0; i < SUFFIX_LENGTH; i++) {
    suffix += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
  }
  return suffix;
}

async function isReferralCodeTaken(code: string): Promise<boolean> {
  const q = query(
    collection(firestore, 'subscription_users'),
    where('referralCode', '==', code),
  );
  const snap = await getDocs(q);
  return !snap.empty;
}

export async function generateReferralCode(
  userId: string,
  fullName: string,
): Promise<string> {
  const firstName = getFirstName(fullName);
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
    const suffix = generateAlphanumericSuffix();
    const code = `${firstName}-${suffix}`;
    const taken = await isReferralCodeTaken(code);
    if (!taken) {
      const userRef = doc(firestore, 'subscription_users', userId);
      await updateDoc(userRef, { referralCode: code });
      return code;
    }
  }
  throw new Error(
    'Não foi possível gerar um código único. Tente novamente em instantes.',
  );
}

export interface ReferredUser {
  id: string;
  fullName: string;
  email: string;
  hasActiveSubscription: boolean;
}

export async function getReferrerIdByCode(code: string): Promise<string | null> {
  if (!code || code.length < 4) return null;
  const normalized = code.trim();
  const q = query(
    collection(firestore, 'subscription_users'),
    where('referralCode', '==', normalized),
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return snap.docs[0].id;
}

export async function getReferredUsers(
  referrerUserId: string,
): Promise<ReferredUser[]> {
  const q = query(
    collection(firestore, 'subscription_users'),
    where('referredBy', '==', referrerUserId),
  );
  const snap = await getDocs(q);
  return snap.docs.map(docSnap => {
    const data = docSnap.data();
    const subscriptions =
      (data.subscriptions as Array<{ status?: string }>) || [];
    const hasActiveSubscription = subscriptions.some(
      s => s?.status === 'Ativa' || s?.status === 'ativa',
    );
    return {
      id: docSnap.id,
      fullName: data.fullName || '—',
      email: data.email || '—',
      hasActiveSubscription,
    };
  });
}
